export default __webpack_public_path__ + "static/media/delaswap.13d27926.png";